import $ = require("jquery");
import Backbone = require("backbone");
import Portal = require("portal-gis");
import Utils = require("../utils");
import Base = require("./base-command");

// not sure why I created this...converts JSON to typescript definitions similar to http://json2ts.com/
class schemaToTypescript extends Base<{}> {

    static about = `Obsolete.  Remove this command`;
    
    execute(args = this.args) {
        var options = this.options;

        let model = new Backbone.Model({ url: options["service"] });

        model.fetch({
            success: () => {
                var subTypes = {};
                var typescript = "";
                for (var attrName in model.attributes) {
                    typescript += convertToTypescript(attrName, model.attributes[attrName], subTypes);
                }
                for (var typeName in subTypes) {
                    typescript += "\n" + subTypes[typeName];
                }
                console.log(typescript);
            }
        });
    }

} 

function convertToTypescript(interfaceName: string, schema: any, types: any) {
    var pre = "interface " + interfaceName + " {";
    var body = "";
    var post = "}";

    for (var typeName in schema) {
        var dataType = schema[typeName];
        if ($.isArray(dataType)) {
            var interfaceName = asInterface(typeName + "Item");
            body += "\t" + typeName + "?: Array<" + interfaceName + ">;\n";
            if (!types[interfaceName]) {
                types[interfaceName] = "pending";
                types[interfaceName] = convertToTypescript(interfaceName, dataType[0], types);
            }
        }
        else if (isPrimitive(dataType)) {
            body += "\t" + typeName + "?: " + asPrimitive(dataType) + ";\n";
        }
        else {
            var interfaceName = asInterface(typeName);
            body += "\t" + typeName + "?: " + interfaceName + ";\n";
            if (!types[interfaceName]) {
                types[interfaceName] = "pending";
                types[interfaceName] = convertToTypescript(interfaceName, dataType, types);
            }
        }
    }

    if (body === "") {
        body = "\t[key: string]: any;\n";
    }
    else if (body === "\tString?: string;\n") {
        body = "\t[key: string]: string;\n";
    }

    return pre + "\n" + body + "\n" + post + "\n";
}

function isPrimitive(dataType: any) {
    return null !== asPrimitive(dataType);
}

function asPrimitive(dataType: any) {
    if ("object" === typeof dataType) return null;
    if ("number" === typeof dataType) return "number";
    if ("String" === dataType) return "string";
    if ("0001-01-01T00:00:00.0000000" === dataType) return "Date";
    if (false === dataType) return "boolean";
    return null;
}

function asInterface(typeName: string) {
    return "I" + typeName.substring(0, 1).toUpperCase() + typeName.substring(1);
}

export = schemaToTypescript; 